import { render, staticRenderFns } from "./message-push-form.vue?vue&type=template&id=37313c54&"
import script from "./message-push-form.vue?vue&type=script&lang=ts&"
export * from "./message-push-form.vue?vue&type=script&lang=ts&"
import style0 from "./message-push-form.vue?vue&type=style&index=0&id=37313c54&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports